function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M34,0C15.2539,0,0,15.252,0,34s15.2539,34,34,34c18.7459,0,34-15.252,34-34S52.7459,0,34,0z",
  fill: "#A9C7D8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132,8c-15.4377,0-28,12.5605-28,28c0,15.4397,12.5623,28,28,28c15.4375,0,28-12.5603,28-28   C160,20.5605,147.4375,8,132,8z",
  fill: "#A9C7D8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M212,16c-11.0273,0-20,8.9729-20,20c0,11.0273,8.9727,20,20,20c11.0271,0,20-8.9727,20-20   C232,24.9729,223.0271,16,212,16z",
  fill: "#A9C7D8"
}));

const SvgMp = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  enableBackground: "new 0 0 40 10",
  id: "mixpanel",
  viewBox: "0 0 232 68",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mp.f1cc17dc.svg";
export { ForwardRef as ReactComponent };